import React, { useContext, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "reactstrap";

import UserContext from "../../contexts/user";
import { AuthContext } from "../../containers/user-auth";

const Login: React.FC = () => {
  const intl = useIntl();
  const userContext = useContext(UserContext);
  const authContext = useContext(AuthContext);

  const { currentEvent } = userContext;
  const { login, setPage } = authContext;

  return (
    <>
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={(values) => {
          login.mutate(values);
        }}
      >
        <Form className="m-t-30">
          <h4>
            <FormattedMessage id="login.header" />
          </h4>
          <div className="form-group m-t-10">
            <Field
              required
              placeholder={intl.formatMessage({ id: "input.email" })}
              className="form-control"
              type="text"
              name="email"
            />
            <ErrorMessage
              className="invalid-feedback"
              name="email"
              component="div"
            />
          </div>
          <div className="form-group">
            <Field
              required
              placeholder={intl.formatMessage({ id: "input.password" })}
              className="form-control"
              type="password"
              name="password"
              minLength="6"
            />
            <ErrorMessage
              className="invalid-feedback"
              name="password"
              component="div"
            />
          </div>
          <div className="login-button-container m-t-20">
            {currentEvent.allowAnonymousAccess ? (
              <Button
                onClick={function () {
                  userContext.setOneTimeShowLogin(false);
                  userContext.setShowLogin(false);
                }}
                color="link"
                type="button"
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage({
                      id: "auth.continue.without.login",
                    }),
                  }}
                ></span>
              </Button>
            ) : (
              <span />
            )}
            <div>
              <Button
                color="primary"
                type="submit"
                disabled={!!login.isLoading}
              >
                <FormattedMessage id="login.header" />
              </Button>
            </div>
          </div>
        </Form>
      </Formik>

      {currentEvent.allowCreateAccount && (
        <div className="common-styles m-t-10 m-b-10">
          {intl.formatMessage({ id: "no.account" })}
          &nbsp;&nbsp;
          <Button onClick={() => setPage("signup")} color="link" type="button">
            {intl.formatMessage({ id: "auth.create.account" })}
          </Button>
        </div>
      )}
      <div className="common-styles m-t-10 m-b-10">
        <Button
          onClick={() => setPage("forgotpassword")}
          color="link"
          type="button"
        >
          {intl.formatMessage({ id: "forgot.password" })} ?
        </Button>
      </div>
    </>
  );
};

export default Login;
